.fullscreen {
	display: block;
	height: 100vh;
	width: 100vw;
	position: fixed;
	top: 0;
	left: 0;
	background-color: var(--elevation-low);
	z-index: 1;
	overflow: auto;
}

.header {
	height: fit-content;
	width: 100%;
	padding: 20px;
	display: flex;
	gap: 8px;
	align-items: end;
	position: fixed;
	z-index: 2;
}

/**
 * Force the close button always to the right
 */
.closeButton {
	margin-left: auto;
}

.content {
	height: fit-content;
	position: relative;
	margin: 80px auto 20px;
}

.default {
	width: 560px;
}

.wide {
	width: 100%;
	max-width: 1120px;
}
